import React, { useState, useEffect, useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import PagedResultSet from 'src/models/common/PagedResultSet';
import { IRootState } from 'src/reducers';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import { useFetch } from 'use-http';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import Assignment from 'src/models/dlcLease/Assignment';
import State from 'src/models/State';
import AssignmentsList from './AssignmentsList';
import Tooltip from 'react-tooltip-portal';
import Button from 'src/components/controls/forms/redesign/FormButton';

const AssignmentsPage = () => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { response, get } = useFetch();
    const dialogContext = useContext<dialogCreators>(DialogContext);

    // TODO: Look into setting up a ts file containing tool tips (similar to DialogName enum)
    const assignToolTip = 'Select "Manage" to update Assignment and batch Lease Recordings.';

    const [assignmentsList, setAssignmentsList] = useState<Array<Assignment>>([]);
    const [states, setStates] = useState<State[]>([]);

    // Tooltip states
    const assignmentRef = useRef(null);
    const [showATip, setShowATip] = useState<boolean>(false);

    useEffect(() => {
        getAssignments();
        getStates();
    }, []);
        
    const getAssignments = async () => {
        let result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/processingMaintenance/assignment`);

        if (response.ok) {
            setAssignmentsList(result);
        } else {
            console.log('getAssignments Error:', result);
            window.alert('Error getting Assignments');
        }
    };
    
    const getStates = async () => {
        let result: PagedResultSet<State> = await get('/v1.0/states/');

        if (response.ok) {
            setStates(result.items);
        } else {
            console.log('getStates Error:', result);
            window.alert('Error getting States');
        }
    };
    
    const onAssign = (assignment?: Assignment) => {
        dialogContext.processing.assignments(assignment, states, () => onUpdate());
    };

    const onUpdate = () => {
        getAssignments();
    };

    const assignmentListWindow = () => {
        return (
            <Panel>
                <div className="dlc-content-panel-header">
                    <div>
                        <Button
                            intent="primary"
                            text="New Assignment"
                            onClick={() => onAssign()}
                            style={{ marginRight: '1rem' }}
                            disabled={states?.length === 0}
                        />
                        <Button
                            intent="primary"
                            text="Group Invoices (WIP)"
                            style={{ marginRight: '1rem' }}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="dlc-content-panel-header">
                    <span>Assignments</span>
                    <span
                        className="tool-tip"
                        ref={assignmentRef}
                        onMouseEnter={() => setShowATip(true)}
                        onMouseLeave={() => setShowATip(false)}
                    >
                        <i className="fa fa-info-circle" />
                    </span>
                    <Tooltip active={showATip} parent={assignmentRef.current} position="top" className="tooltip">
                        <div>{assignToolTip}</div>
                    </Tooltip>
                </div>
                <div style={{ overflow: 'auto', maxHeight: '65vh' }}>
                    {!!assignmentsList && (
                        <AssignmentsList
                            assignments={assignmentsList}
                            onUpdateAssignment={onAssign}
                        />
                    )}
                    {!assignmentsList && <LoadingSpinner />}
                </div>
            </Panel>
        );
    };

    return (
        <Page>
            <Page.Section>
                {assignmentListWindow()}
            </Page.Section>
        </Page>
    );
};

export default AssignmentsPage;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/AssignmentsPage.tsx